import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import ActionsMenu from '../ui/ActionsMenu'
import DownloadIcon from '../ui/icons/DownloadIcon'
import ProgressionService from '../../services/api/ProgressionService'
import { showToast } from '../shared/Toast'

const TRIGGER_BTN_CLASS = 'tw:inline-flex tw:items-center tw:justify-center '
  + 'tw:w-9 tw:h-9 tw:bg-white tw:border tw:border-solid tw:border-gray-300 '
  + 'tw:rounded! tw:text-gray-700 tw:hover:bg-gray-50 tw:cursor-pointer'

const SUCCESS_MSG = 'L’export du tableau des opérateurs vous sera envoyé par email.'
const ERROR_MSG = 'Une erreur est survenue lors de l’export.'

const ExportMenu = ({ collectId, draftId, exportParams, toastContainerId }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [exporting, setExporting] = useState(false)

  const handleToggle = useCallback(event => {
    const target = event.currentTarget
    setAnchorEl(current => current ? null : target)
  }, [])
  const handleClose = useCallback(() => setAnchorEl(null), [])

  const handleExport = useCallback(async format => {
    handleClose()
    if (exporting)
      return
    setExporting(true)
    try {
      await ProgressionService.exportOperatorProgress(collectId, draftId, { ...exportParams, format })
      showToast(SUCCESS_MSG, 'success', toastContainerId)
    } catch (error) {
      showToast(error.message || ERROR_MSG, 'error', toastContainerId)
    } finally {
      setExporting(false)
    }
  }, [collectId, draftId, exportParams, exporting, handleClose, toastContainerId])

  const items = [
    { label: 'Exporter PDF', icon: DownloadIcon, onClick: () => handleExport('pdf') },
    { label: 'Exporter Excel', icon: DownloadIcon, onClick: () => handleExport('xlsx') }
  ]

  return (
    <>
      <button
        aria-label="Exporter le tableau des opérateurs"
        className={TRIGGER_BTN_CLASS}
        disabled={exporting}
        type="button"
        onClick={handleToggle}
      >
        <DownloadIcon className="tw:w-3 tw:h-3" />
      </button>
      <ActionsMenu
        anchorEl={anchorEl}
        ariaLabel="Options d’export"
        isOpen={Boolean(anchorEl)}
        items={items}
        onClose={handleClose}
      />
    </>
  )
}

ExportMenu.propTypes = {
  collectId: PropTypes.number.isRequired,
  draftId: PropTypes.number,
  exportParams: PropTypes.shape({
    endDate: PropTypes.string,
    operatorId: PropTypes.string,
    resourceSearch: PropTypes.string,
    sortBy: PropTypes.string,
    sortDirection: PropTypes.string,
    startDate: PropTypes.string,
    variableId: PropTypes.string
  }).isRequired,
  toastContainerId: PropTypes.string.isRequired
}

ExportMenu.defaultProps = {
  draftId: null
}

export default ExportMenu
